export default __webpack_public_path__ + "static/syncstage-built-for-audio-quality-ad6edd3e275fb30ade4f4b563d1e1444.png";